import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, Clock, XCircle, Loader2, CalendarX2 } from "lucide-react";
import { api } from "@/lib/api";

export default function StripeReturn() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("checking");
  const [refunded, setRefunded] = useState(false);
  const [charged, setCharged] = useState(false);

  useEffect(() => {
    if (params.get("paypal")) { setStatus("paid"); return; }
    const sid = params.get("session_id");
    if (!sid) { setStatus("failed"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.post("/stripe/confirm-session", { session_id: sid });
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.payment_status === "slot_unavailable") { setRefunded(!!data.refunded); setCharged(!!data.charged); setStatus("slot"); return; }
      } catch (e) { /* retry */ }
      if (++tries < 6) setTimeout(poll, 2000);
      else setStatus("pending");
    };
    poll();
  }, [params]);

  const config = {
    checking: { icon: Loader2, color: "text-[#D4AF37]", title: "Confirming payment…", text: "Hang tight while we verify your transaction.", spin: true },
    paid: { icon: CheckCircle2, color: "text-green-400", title: "Booking Confirmed!", text: "Your session is locked in. A confirmation email is on its way." },
    pending: { icon: Clock, color: "text-amber-400", title: "Payment Pending", text: "We haven't received confirmation yet. If you completed payment, your booking will update shortly." },
    failed: { icon: XCircle, color: "text-red-400", title: "Payment Not Completed", text: "Something went wrong. Please try booking again." },
    slot: { icon: CalendarX2, color: "text-orange-400", title: "Time Slot No Longer Available", text: `Sorry — another client booked this exact time moments before your payment went through. ${!charged ? "You have NOT been charged — the temporary hold on your card has been released automatically." : refunded ? "Your payment has been fully refunded (5–10 business days)." : "Our team will refund you or help you reschedule shortly."} Please pick a new time.`, cta: true },
  }[status];

  const Icon = config.icon;

  return (
    <div className="min-h-[80vh] pt-28 flex items-center justify-center px-5" data-testid="stripe-return-page">
      <div className="glass rounded-3xl p-10 max-w-md text-center">
        <Icon className={`mx-auto ${config.color} ${config.spin ? "animate-spin" : ""}`} size={56} />
        <h1 className="font-display text-3xl text-white mt-6" data-testid="return-status-title">{config.title}</h1>
        <p className="text-white/60 mt-3">{config.text}</p>
        <div className="flex flex-col gap-3 mt-8">
          {config.cta && <Link to="/book" data-testid="pick-new-time-btn" className="btn-gold rounded-full px-8 py-3 uppercase tracking-wide font-mono-label text-sm">Pick a New Time</Link>}
          <Link to="/my-bookings" className="btn-gold rounded-full px-8 py-3 uppercase tracking-wide font-mono-label text-sm">View My Bookings</Link>
          <Link to="/" className="text-white/60 hover:text-white text-sm">Back to Home</Link>
        </div>
      </div>
    </div>
  );
}
